module.exports = __webpack_public_path__ + "img/mergePay.2a79ff8e.png";